import { isTranslationAvailable } from '@fs/zion-locale'

type TFunc = (key: string, defaultValue: string) => string

export default function getPageTitle(pathname: string, t: TFunc): string {
  const normalizedPathname = pathname.length > 1 ? pathname.replace(/\/$/, '') : pathname
  const titleMap: Record<string, string> = {
    '/': isTranslationAvailable('rootstech.home.page-title')
      ? t('rootstech.home.page-title', 'RootsTech Genealogy Conference & Learning Library')
      : t('navigation.home.label', 'Home'),
    '/search': t('navigation.on-demand.label', 'On Demand'),
    '/library': t('library.header', 'Video Library'),
    '/schedule': t('navigation.schedule.label', 'Schedule'),
    '/user/playlists': t('navigation.playlists.label', 'My Playlists'),
    '/user/history': t('navigation.watch-history.label', 'Watch History'),
    '/user/likes': t('navigation.my-likes.label', 'My Likes'),
    '/user/my-likes': t('navigation.my-likes.label', 'My Likes'),
    '/playlists': t('navigation.playlists.label', 'My Playlists'),
    '/playlist': t('navigation.playlists.label', 'My Playlists'),
    '/history': t('navigation.watch-history.label', 'Watch History'),
    '/dashboard': t('navigation.dashboard.label', 'Dashboard'),
    '/dashboard/access': t('navigation.dashboard-access.label', 'Dashboard Access'),
    '/dashboard/authorization': t('navigation.dashboard-authorization.label', 'Dashboard Authorization'),
    '/subscription': t('conference-announce.subscribe.for.updates', 'Subscribe for Updates'),
    '/user': t('navigation.user.label', 'User'),
    '/faq': t('navigation.faq.label', 'Frequently Asked Questions'),
    '/about': t('about.banner.heading', 'About Us'),
    '/getting-started': t('search.getting-started.label', 'Getting Started'),
    '/registration': t('event.reg.attend', 'Register for RootsTech'),
    '/registration/in-person': t('event.reg.attend.in-person.register', 'In-Person Event Registration'),
    '/registration/online': t('event.reg.attend.virtual.title', 'Online Event Registration'),
    '/registration/online/arc': t(
      'event.reg.attend.arc.register',
      'Archivist and Record Custodian Symposium Online Registration'
    ),
    '/registration/in-person/expohall': t('event.reg.attend.expohall.register', 'Expo Hall Only Registration'),
    '/registration/in-person/discovery-day': t('event.reg.attend.discovery-day.register', 'Discovery Day Registration'),
  }
  return titleMap[normalizedPathname] ?? t('site-title', 'RootsTech')
}
